module.exports = __webpack_public_path__ + "static/media/avatar.f8894c24.png";